"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowButton = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const clsx_1 = __importDefault(require("clsx"));
const ArrowButton = (props) => {
    const getIcon = (iconType) => {
        switch (iconType) {
            case 'left':
                return common_1.ICONS.chevron_left;
            case 'right':
                return common_1.ICONS.chevron_right;
            case 'up':
                return common_1.ICONS.chevron_drop_up;
            case 'down':
                return common_1.ICONS.chevron_drop_down;
            default:
                break;
        }
    };
    const { mainColor, disabled = false, className, onClick, type } = props;
    const classNames = (0, clsx_1.default)(mainColor ? 'main-color-set' : 'second-color-set', disabled ? 'disabled' : '', type, className);
    return (react_1.default.createElement("div", { className: "arrow-button-component", "data-testid": "arrow-button-component" },
        react_1.default.createElement("button", { className: classNames, disabled: disabled, onClick: !disabled ? onClick : () => { } },
            react_1.default.createElement("img", { src: getIcon(type), alt: type }))));
};
exports.ArrowButton = ArrowButton;
